// Match-beeldmerk (hub met zes satellieten). Een bron voor rail, zoekbalk en de
// Match-pagina; nooit de path-data kopieren.
export default function MatchIcon({ size = 16, style }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true" style={style}>
      <circle cx="12" cy="12" r="2.6" />
      <circle cx="12" cy="3.5" r="1.7" />
      <circle cx="12" cy="20.5" r="1.7" />
      <circle cx="4.6" cy="7.75" r="1.7" />
      <circle cx="19.4" cy="7.75" r="1.7" />
      <circle cx="4.6" cy="16.25" r="1.7" />
      <circle cx="19.4" cy="16.25" r="1.7" />
      <line x1="12" y1="9.4" x2="12" y2="5.2" />
      <line x1="12" y1="14.6" x2="12" y2="18.8" />
      <line x1="9.75" y1="10.7" x2="6.1" y2="8.6" />
      <line x1="14.25" y1="10.7" x2="17.9" y2="8.6" />
      <line x1="9.75" y1="13.3" x2="6.1" y2="15.4" />
      <line x1="14.25" y1="13.3" x2="17.9" y2="15.4" />
    </svg>
  );
}
